import {makeStyles} from '@material-ui/core/styles'
import {CancelButton, reExportedColors, EditModeButton, FeedbackSnackbar, Text} from '../../1elements'
import LoaderBackdrop from '../../2compounds/LoaderBackdrop'
import SaveButton from '../../1elements/Buttons/TextButtons/SaveButton'
import GoBackButton from '../../1elements/Buttons/IconButtons/GoBackButton'
import ResetAllToDefaultButton from '../../1elements/Buttons/TextButtons/ResetAllToDefaultButton'

const ConfigurationWrapper = ({header, children, onEditMode, setOnEditMode, isSnackbarOpen, setIsSnackbarOpen, isLoading, resetToDefault, handleCancel, handleSave, formik, hideSaveCancel = false}) => {
    const classes = useStyles({onEditMode: onEditMode && !hideSaveCancel})

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Text className={classes.pageHeader}>{header}</Text>
                <div className={classes.headerButtonDiv}>
                    <EditModeButton onEditMode={onEditMode} setOnEditMode={setOnEditMode} />
                    <GoBackButton className={classes.goBackButton} />
                </div>
            </div>
            <div className={classes.scrollableDiv}>
                {children}
            </div>
            {!hideSaveCancel && <div className={classes.buttonDiv}>
                {resetToDefault && onEditMode && (
                  <ResetAllToDefaultButton onClick={resetToDefault} />
                )}
                <div className={classes.headerButtonDiv}>
                  <CancelButton onClick={handleCancel} />
                  {formik ? (<SaveButton  />) : (<SaveButton onClick={handleSave} />)}
                </div>

            </div>}
            <FeedbackSnackbar snackbar={isSnackbarOpen} setSnackbar={setIsSnackbarOpen} />
            <LoaderBackdrop open={isLoading} />
        </div>
    )
}

export default ConfigurationWrapper

const useStyles = makeStyles(()=>({
    root: {
        position: 'relative',
        height: 'calc(100vh - 43px)',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '15px 0 30px'
    },
    scrollableDiv: {
        height: props => props.onEditMode ? '82%' : '90%',
        overflowY: 'auto'
    },
    buttonDiv: {
        margin: '0',
        padding: 20,
        position: 'sticky',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        bottom: 0,
        height: props => props.onEditMode ? 'auto' : 0,
        opacity: props => props.onEditMode ? 1 : 0,
        overflowY: props => props.onEditMode ?  'visible' : 'hidden',
        transition: 'height .25s, opacity .25s',
        paddingTop: 10,
        paddingRight: 30,
        boxShadow: '0px 0px 6px #00000029',
        '&>*': {
            margin: 5
        }
    },
    resetButton: {
        margin: '5px auto 5px 0 !important'
    },
    goBackButton: {
        marginLeft: 20
    },
    pageHeader: {
        fontSize: "22px",
        fontWeight: "bold",
        fontFamily: "Lato",
        color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    headerButtonDiv: {
        display: 'flex',
        alignItems: 'center'
    },
}))
